<template>
  <div>
    <doctor-header></doctor-header>
    <div class="header-separator"></div>
    <div style="background-color: rgba(255, 255, 255, .9); margin-top: 200px;">
      <div v-if="verifiedNumber== undefined">
        <span class="doctors-container--sections text-uppercase">Czekaj... </span><br><br>
        <img src="/static/images/spinner.gif"  />
      </div>
      <v-form ref="form" id="needs-validation" v-model="valid" lazy-validation class="pt-3" v-if="verifiedNumber > 0">
        <v-container class="site-padding">
          <v-layout row wrap class="register-form mx-1">
            <v-flex xs12 class="text-xs-left my-text">
              <h1 class="register-form--header">formularz rejestracyjny forum jaskry</h1>
              <div class="sparator-container pt-4">
                <div class="sparator-rectangle"></div>
              </div>
              <span>Przed przystąpieniem do akcji prosimy o&nbsp;zapoznanie sie z</span>
              <router-link :to="{ name: 'ForumProgram' }" class="register-form--links">programem forum.</router-link><br>
              <span>Za udział w Forum </span><span class="register-form--sections"> zostaną przyznane 4 punkty edukacyjne.</span><br>
              <div>
                <span class="register-form--sections">uwaga!</span>
                <span>Liczba miejsc ograniczona.</span>
              </div>
              <div class="pt-3">
                <h1><span class="register-form--sections">Pozostało wolnych miejsc:</span> <span class="c-green">{{ verifiedNumber }}</span>
                </h1>
              </div>
            </v-flex>
          </v-layout>
        </v-container>
        <v-container class="site-bottom-padding">
          <v-layout row wrap>
            <v-flex xs12 md6 lg4 class="mb-3">
              <v-layout>
                <v-flex xs4 md12 class="text-xs-left">
                  <div class="register-container--download px-2">
                    <v-avatar
                      :size="60"
                      color="rgb(39, 82, 113)"
                    >
                      <img src="/static/images/human-icon.svg" alt="" style="height: 60%; border-radius: 0">
                    </v-avatar>
                    <div class="register-container--download-text">
                      <span class="register-container--sections">dane zgłaszającego</span>
                    </div>
                  </div>
                </v-flex>
              </v-layout>
            </v-flex>
          </v-layout>
        </v-container>
        <v-container class="site-padding">
          <v-layout row wrap class="register-form mx-1">
            <v-flex xs12 md6 class="text-xs-left px-md-3 pl-md-0 pl-2 pr-md-0 pr-4">
              <v-select
                :items="items"
                label="Rodzaj uczestnika"
                solo
                v-model="participant.type"
                :rules="nameRules"
              ></v-select>
            </v-flex>
            <v-flex xs12 md6 class="text-xs-left px-md-3 pl-md-0 pl-2 pr-md-0 pr-4"
                    v-if="participant.type !== 'student'">
              <v-text-field
                label="PWZ"
                solo
                v-model="participant.pwz"
                :rules="pwzRules"
                @change='validatePWZ($event, "participant.pwz")'
              ></v-text-field>
            </v-flex>
            <v-flex xs12 md6 class="text-xs-left px-md-3 pl-md-0 pl-2 pr-md-0 pr-4">
              <v-text-field
                label="Imię"
                solo
                v-model="participant.first_name"
                :rules="nameRules"
              ></v-text-field>
            </v-flex>
            <v-flex xs12 md6 class="text-xs-left px-md-3 pl-md-0 pl-2 pr-md-0 pr-4">
              <v-text-field
                label="Nazwisko"
                solo
                v-model="participant.last_name"
                :rules="nameRules"
              ></v-text-field>
            </v-flex>
            <v-flex xs12 md6 class="text-xs-left px-md-3 pl-md-0 pl-2 pr-md-0 pr-4">
              <v-text-field
                label="Telefon"
                solo
                v-model="participant.phone"
                mask="###########"
                :rules="nameRules"
              ></v-text-field>
            </v-flex>
            <v-flex xs12 md6 class="text-xs-left px-md-3 pl-md-0 pl-2 pr-md-0 pr-4">
              <v-text-field
                label="E-mail"
                solo
                v-model="participant.email"
                :rules="emailRules"
              ></v-text-field>
            </v-flex>
            <v-flex xs12 md6 class="text-xs-left px-md-3 pl-md-0 pl-2 pr-md-0 pr-4">
              <v-text-field
                label="Ulica, numer"
                solo
                v-model="participant.address"
                :rules="nameRules"
              ></v-text-field>
            </v-flex>
            <v-flex xs12 md6 class="text-xs-left px-md-3 pl-md-0 pl-2 pr-md-0 pr-4">
              <v-text-field
                label="Kod pocztowy, miejscowość"
                solo
                v-model="participant.city"
                :rules="nameRules"
              ></v-text-field>
            </v-flex>
            <v-flex xs12 class="text-xs-left px-md-3 pl-md-0 pl-2 pr-md-0 pr-4 term-container">
              <div class="two-column">
                <div class="single-col">
                  <div class="styled-input-container styled-input--rounded">
                    <div class="styled-input-single">
                      <input type="checkbox"
                             v-model="participant.accepted1"
                             v-validate="'required'"
                             data-vv-name="participant.accepted1"
                             data-vv-as="zgody"
                             name="accepted1" id="checkbox3-example-one"/>
                      <label for="checkbox3-example-one">
                        Wyrażam zgodę na przetwarzanie przez LPT Group sp. z&nbsp;o.o.
                        z&nbsp;siedzibą w&nbsp;Łodzi, ul. Gdańska 126/128,
                        90-520 moich danych osobowych zawartych w&nbsp;formularzu rejestracyjnym w&nbsp;celu i&nbsp;zakresie
                        niezbędnym do rejestracji na konferencję organizowaną przez LPT Grup Sp. z&nbsp;o.o.
                        <br>W związku z&nbsp;wejściem nowego rozporządzenia Unii Europejskiej o&nbsp;ochronie danych
                        osobowych tzw.
                        RODO wyrażam zgodę na przetwarzanie moich danych osobowych zawartych w&nbsp;niniejszym
                        zgłoszeniu dla potrzeb
                        niezbędnych do informowania o&nbsp;Konferencjach i&nbsp;Zjazdach organizowanych przez firmę LPT
                        Group sp. z&nbsp;o.o. z&nbsp;siedzibą w&nbsp;Łodzi,
                        ul. Gdańska 126/128 , 90-520 Łódź (zgodnie z&nbsp;Rozporządzeniem Parlamentu Europejskiego i&nbsp;Rady
                        (UE) 2016/679 - RODO/GDPR z&nbsp;dnia 27 kwietnia 2016 roku,
                        ustawy o&nbsp;ochronie danych osobowych z&nbsp;dnia 10 maja 2018&nbsp;r.).</label>
                      <div class="v-messages__wrapper error--text">
                        <i v-show="errors.has('participant.accepted1')" class="fa fa-warning"></i>
                        <span v-show="errors.has('participant.accepted1')" class="v-messages__message v-messages">{{ errors.first('participant.accepted1') }}</span>
                      </div>
                    </div>
                    <div class="styled-input-single">
                      <input type="checkbox" v-model="participant.accepted2"
                             name="accepted2" value="0" id="checkbox3-example-two"/>
                      <label for="checkbox3-example-two">Wyrażam zgodę na przesyłanie mi informacji handlowych środkami
                        komunikacji elektronicznej przez: Polskie Towarzystwo Okulistyczne z&nbsp;siedzibą w&nbsp;Warszawie
                        oraz podmioty współpracujące w&nbsp;szczególności z&nbsp;LPT Group sp.&nbsp;z o.o. z&nbsp;siedzibą
                        w&nbsp;Łodzi, zgodnie z&nbsp;ustawą z&nbsp;dnia 18 lipca 2002&nbsp;r. o&nbsp;świadczeniu usług
                        drogą elektroniczną (Dz.&nbsp;U. z&nbsp;2002&nbsp;r. Nr&nbsp;144, poz. 1204 z&nbsp;późn. zm.).
                        Wyrażam zgodę na przetwarzanie moich danych osobowych przez Polskie Towarzystwo
                        Okulistyczne z&nbsp;siedzibą w&nbsp;Warszawie w&nbsp;celach marketingowych oraz na przekazywanie
                        mi propozycji zawarcia umowy przy użyciu telefonu zgodnie z&nbsp;Ustawą z&nbsp;dnia 16&nbsp;lipca
                        2004&nbsp;r.
                        Prawo telekomunikacyjne (tj. Dz.&nbsp;U. z&nbsp;2014&nbsp;r. poz. 243).<br>
                        Oświadczam, że zostałam(em) poinformowana(y) o&nbsp;prawie wglądu do moich danych i&nbsp;dokonywaniu
                        ich zmian.</label>
                    </div>
                    <div class="styled-input-single">
                      <input type="checkbox"
                             v-model="participant.accepted3"
                             v-validate="'required'"
                             data-vv-name="participant.accepted3"
                             data-vv-as="zgody"
                             name="accepted3"
                             id="checkbox3-example-three"/>
                      <label for="checkbox3-example-three">Akceptuję
                        <router-link :to="{ name: 'ForumRegulations' }" class="register-form--links">regulamin.
                        </router-link>
                      </label>
                      <div class="v-messages__wrapper error--text">
                        <i v-show="errors.has('participant.accepted3')" class="fa fa-warning"></i>
                        <span v-show="errors.has('participant.accepted3')" class="v-messages__message v-messages">{{ errors.first('participant.accepted3') }}</span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </v-flex>
          </v-layout>
        </v-container>


        <v-container class="site-padding">
          <v-layout row wrap class="register-form mx-1">
            <v-flex xs12 class="text-xs-left px-md-3 pl-md-0 pl-2 pr-md-0 pr-4 term-container">
              <div class="two-column">
                <div class="single-col">
                  <div class="styled-input-container styled-input--rounded">
                    <div class="styled-input-single">

                      <input type="checkbox" v-model="is_merchant_company"
                             name="is_merchant_company" value="0" id="is_merchant_company"/>
                      <label for="is_merchant_company">Faktura na przedsiębiostwo</label>
                    </div>
                  </div>
                </div>
              </div>
            </v-flex>
            <v-flex xs12 md6 class="text-xs-left px-md-3 pl-md-0 pl-2 pr-md-0 pr-4">
              <v-text-field
                v-show="is_merchant_company"
                label="Nazwa firmy"
                solo
                v-model="participant.name"
                :rules="nameRules"
              ></v-text-field>
            </v-flex>
            <v-flex xs12 md6 class="text-xs-left px-md-3 pl-md-0 pl-2 pr-md-0 pr-4">
              <v-text-field
                v-show="is_merchant_company"
                label="NIP"
                type="number"
                solo
                v-model="participant.nip"
                :rules="nipRules"
              ></v-text-field>
            </v-flex>

            <v-flex xs12 md6 class="text-xs-left px-md-3 pl-md-0 pl-2 pr-md-0 pr-4">
              <v-text-field
                v-show="!is_merchant_company"
                label="Imię i nazwisko"
                solo
                v-model="participant.name"
                :rules="nameRules"
              ></v-text-field>
            </v-flex>
            <v-flex xs12 md12 class="text-xs-left px-md-3 pl-md-0 pl-2 pr-md-0 pr-4">
              <v-text-field
                label="Adres"
                solo
                persistent-hint
                v-model="participant.merchant_address"
                :rules="nameRules"
              ></v-text-field>
            </v-flex>
            <v-flex xs12 md6 class="text-xs-left px-md-3 pl-md-0 pl-2 pr-md-0 pr-4">
              <v-text-field
                label="Kod pocztowy"
                solo
                mask="##-###"
                hint="00-111"
                persistent-hint
                v-model="participant.merchant_post_code"
                :rules="nameRules"
              ></v-text-field>
            </v-flex>
            <v-flex xs12 md6 class="text-xs-left px-md-3 pl-md-0 pl-2 pr-md-0 pr-4">
              <v-text-field
                label="Miasto"
                solo
                persistent-hint
                v-model="participant.merchant_city"
                :rules="nameRules"
              ></v-text-field>
            </v-flex>
          </v-layout>
        </v-container>

        <v-container>
          <v-layout row class="mt-3" @click="submit">
            <v-flex class="xs12 sm6">
              <my-button
                toName="ForumRegister"
                title="Zarejestruj się"
                :text="isDisabled ? '<span>Wysyłam</span>' : '<span>Zarejestruj i zapłać</span>'"
                customClass="doctor rect-x1"
              />
            </v-flex>
          </v-layout>
        </v-container>
      </v-form>

      <v-container v-else>
        <v-layout align-center justify-center row wrap class="register-form mx-1 py-3">
          <v-flex xs12 class="text-xs-left">
            <h1 class="register-form--header">formularz rejestracyjny forum jaskry</h1>
            <div class="sparator-container pt-4">
              <div class="sparator-rectangle"></div>
            </div>
            <div>
              <span class="register-form--sections">uwaga!</span>
              <span>Wszystkie miejsca zostały juz zarezerwowane. Zapraszamy do zapisów na transmisję onlinę. Prosimy o skorzystania z <router-link
                :to="{ name: 'ForumOnline' }" class="register-form--links">panelu rejestacji</router-link></span>
            </div>
            <div>
              <h1 class="register-form--sections">Liczba miejsc ograniczona!</h1>
              <div>
                <span>Transmisja będzie dostępna w&nbsp;dniu 9&nbsp;marca 2020&nbsp;r. w&nbsp;godzinach 9:00-14:00 na stronie:</span>
                <a href="https://pto.com.pl/pfj" target="_blank" class="register-form--links"><strong>https://pto.com.pl/pfj</strong></a>
              </div>
            </div>
          </v-flex>
        </v-layout>
      </v-container>
      <v-dialog v-model="dialog1" persistent max-width="600px">
        <v-card>
          <v-card-text>
            <h3>Dziękujemy za rejestację placówki. Proszę sprawdzić email.</h3>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="blue darken-1" flat @click="dialog1 = false">OK</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <v-dialog v-model="dialog2" persistent max-width="600px">
        <v-card>
          <v-card-text>
            <h3>Błąd! {{ this.validationErrors }} </h3>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="blue darken-1" flat @click="dialog2 = false">OK</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <v-dialog v-model="dialog3" persistent max-width="600px">
        <v-card>
          <v-card-text>
            <h3>Wystąpił następujący błąd:</h3>
            <ul class="alert alert-danger">
              <li v-for="(value, key, index) in validationErrors">@{{ value }}</li>
            </ul>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="blue darken-1" flat @click="dialog3 = false">OK</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </div>
    <div class="header-separator" style="height: 50px;"></div>
  </div>
</template>

<script>
import DoctorHeader from '@/components/partials/DoctorHeader';
import MyButton from '@/components/partials/Button';

export default {
  data() {
    return {
      dialog1: false,
      dialog2: false,
      dialog3: false,
      isRegistred: false,
      isDisabled: false,
      is_merchant_company: false,
      valid: true,
      validationErrors: '',
      items: [
        'student',
        'lekarz',
        'rezydent',
      ],
      participant: {
        type: '',
        pwz: '',
        first_name: '',
        last_name: '',
        phone: '',
        email: '',
        address: '',
        city: '',
        token: window.localStorage.getItem('wgwtoken'),
        order_token: '',
        accepted1: '',
        accepted2: '',
        accepted3: '',
        name: '',
        merchant_address: '',
        merchant_post_code: '',
        merchant_city: '',
        nip: '',
      },
      nameRules: [
        v => !!v || 'Pole jest wymagane',
      ],
      nipRules: [
        v => this.validateNip(v) || 'Nip jest wymagany, jeśli faktura ma być wystawiona na przedsiębiorstwo',
      ],
      emailRules: [
        v => !!v || 'E-mail jest wymagany',
        v => /.+@.+/.test(v) || 'Zły format',
      ],
      pwzRules: [
        v => !!v || 'Numer PWZ jest wymagany',
        v => this.validatePWZ(v) || 'Zły format',
      ],
      verifiedNumber: undefined,
    };
  },
  components: {
    DoctorHeader,
    MyButton,
  },
  mounted() {
    // this.fill();
    this.fetchVerifiedParticipants();
  },
  methods: {
    fill() {
      this.participant.first_name = 'Rafał';
      this.participant.last_name = 'No';
      this.participant.phone = '666666666';
      this.participant.email = 'asd@wp.pl';
      this.participant.type = 'student';
      this.participant.address = 'ulica';
      this.participant.city = '';
      this.participant.pwz = '6555555';
      this.participant.accepted1 = '';
      this.participant.accepted2 = true;
      this.participant.accepted3 = '';
      this.participant.name = '';
      this.participant.merchant_address = '';
      this.participant.merchant_post_code = '';
      this.participant.merchant_city = '';
      this.participant.nip = '';
    },
    isNumber(value) {
      if (value === null) {
        return true;
      }
      return /^-?(?:0|0\.\d*|[1-9]\d*\.?\d*)$/.test(value);
    },
    validateNip(nip) {
      if (this.is_merchant_company && nip < 10000) {
        return false;
      }
      else if(!this.is_merchant_company){
        this.participant.nip = '';
      }

      return true;
    },
    clearForm() {
      this.participant.first_name = '';
      this.participant.last_name = '';
      this.participant.phone = '';
      this.participant.email = '';
      this.participant.type = '';
      this.participant.address = '';
      this.participant.city = '';
      this.participant.pwz = '';
      this.participant.accepted1 = '';
      this.participant.accepted2 = '';
      this.participant.accepted3 = '';
      this.participant.name = '';
      this.participant.merchant_address = '';
      this.participant.merchant_post_code = '';
      this.participant.merchant_city = '';
      this.participant.nip = '';
    },
    showErrors(error) {
      this.$toasted.error(error, {
        theme: 'primary',
        position: 'bottom-right',
        duration: 5000,
      });
    },
    submit() {
      this.$validator.validateAll()
        .then(() => {
          if (this.$refs.form.validate()) {
            this.isDisabled = true;
            this.isRegistred = true;
            window.localStorage.setItem('order_token', Math.random().toString(36).substring(2, 15) + Math.random().toString(36).substring(2, 15));

            const data = {
              'participant':
                {
                  'type': this.participant.type,
                  'first_name': this.participant.first_name,
                  'last_name': this.participant.last_name,
                  'email': this.participant.email,
                  'phone': this.participant.phone,
                  'pwz': this.participant.pwz,
                  'address': this.participant.address,
                  'city': this.participant.city,
                  'order_token': window.localStorage.getItem('order_token'),
                  'token': window.localStorage.getItem('wgwtoken'),
                  'accepted1': this.participant.accepted1,
                  'accepted2': this.participant.accepted2,
                  'accepted3': this.participant.accepted3,
                  'name': this.participant.name,
                  'merchant_address': this.participant.merchant_address,
                  'merchant_post_code': this.participant.merchant_post_code,
                  'merchant_city': this.participant.merchant_city,
                  'nip': this.participant.nip
                },
            };

            this.axios({
              method: 'POST',
              url: `${process.env.APP_URL}/api/forum-register`,
              data,
            }).then((response) => {
              this.isDisabled = false;
              window.location = `${process.env.APP_URL}/payments/${response.data}`;

            }, err => {
              this.validationErrors = err.response.data.errors;
              this.dialog2 = true;
              this.isDisabled = false;
            });

          } else {
            window.scrollTo(0, 0);
          }
        });
    },
    validatePWZ(value) {
      if (value === '') {
        return true;
      }
      const reg = /^[0-9]{7}$/;
      if (reg.test(value) === false) {
        return false;
      }
      const k = parseInt(value.substr(0, 1));
      const g = parseInt(value.substr(1, 1));
      const b = parseInt(value.substr(2, 1));
      const c = parseInt(value.substr(3, 1));
      const d = parseInt(value.substr(4, 1));
      const e = parseInt(value.substr(5, 1));
      const f = parseInt(value.substr(6, 1));
      const sum = 1 * g + 2 * b + 3 * c + 4 * d + 5 * e + 6 * f;
      const checksum = sum % 11;
      if (sum === 0) {
        return false;
      } else if (checksum === k) {
        return true;
      }
      return false;
    },
    fetchVerifiedParticipants() {
      this.axios({
        method: 'GET',
        url: `${process.env.APP_URL}/api/get-forum-participants`,
      })
        .then((result) => {
          this.verifiedNumber = 70 - result.data.length;
        });
    },
  },
  computed: {},
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="stylus">
  .c-green {
    color: #007F00;
  }

  .term-container--position {
    align-items: baseline !important;
  }

  .navigation-container {
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    justify-content: flex-end;
    align-content: end;
    align-items: end;
  }

  .navigation-container--position {
    order: 0;
    flex: 0 1 auto;
    align-self: center;
    border-bottom: 5px solid #fff;
  }

  .banner {
    background-color: transparent;
  }

  .wrapper {
    width: 100%;
    margin: 0 auto;
  }

  .banner .text-container {
    font-family: 'Fira Sans', sans-serif;
    text-align: left;
    color: #aaa;
    display: block;
    vertical-align: middle;
  }

  .banner img {
    float: left;
  }

  .time-container {
    display: inline-flex;
    width: 100%;
  }

  .time-container--separator {
    width: 145px;
    padding-right: 5px;
  }

  .register-form--inputs {
    width: 100%;
    padding: 12px 20px;
    margin: 8px 0;
    box-sizing: border-box;
  }

  .register-form--header {
    font-size: 26px;
    font-family: 'Fira Sans', sans-serif;
    font-weight: 900;
    color: #a41611;
    text-transform: uppercase;
  }

  .register-form--links {
    color: #a41611;
    font-family: 'Fira Sans', sans-serif;
  }

  .register-form--sections {
    color: #275271;
    font-family: 'Fira Sans', sans-serif;
    font-weight: 900;
    text-transform: uppercase;
  }

  .register-form--sections-brown {
    color: #a41611;
  }

  .register-form--sections-slim {
    color: #000;
    font-weight: 500;
    text-transform: lowercase;
  }

  .register-form--icons {
    background: #275271;
    vertical-align: middle;
    border-radius: 50%;
    width: 50px;
    height: 50px;
    line-height: 50px;
    border: none;
    padding: 5px;
  }

  .register-form--icons-brown {
    background: #a82824;
  }

  .sparator-container {
    border-bottom: 1px solid black;
    margin-bottom: 10px;
  }

  .sparator-rectangle {
    width: 115px;
    height: 8px;
    background-color: #275271;
  }

  .no-padding {
    padding: 0px !important;
    margin-top: 7px;
  }

  .register-bg {
    position: relative;
  }

  .register-bg::before {
    top: 0;
    left: 0;
    right: 0;
    width: 100%;
    height: 100%;
    content: '';
    position: fixed;
    opacity: 0.1;
    background-image: url('./../assets/images/register-bg.png');
    background-repeat: repeat;
    background-position: center center;
  }

  .doctor-header {
    background: #a82824;
    opacity: 0.9;
  }

  .free-main-header {
    background: #d9e7ee;
    opacity: 0.9;
  }

  .free-main-header--text {
    font-family: 'Fira Sans', sans-serif;
    font-size: 12px;
  }

  .main-header--wgw {
    width: 125px;
  }

  .main-header--pto {
    width: 90px;
  }

  @media only screen and (min-width: 1024px) and (max-width: 2560px) {
    .main-header--wgw {
      width: 240px;
    }

    .main-header--pto {
      width: 200px;
    }
  }

  .main-header--free {
    width: 280px;
  }

  .button-container-blue {
    background: #275271;
    opacity: 0.9;
  }

  .button-container-red {
    background: #a82824;
    opacity: 0.9;
    position: relative;
  }

  .button-container--register {
    font-family: 'Fira Sans', sans-serif;
    font-size: 40px;
    line-height: 40px;
    font-weight: 900;
    color: #fff;
    text-decoration: none;
    text-transform: uppercase;
  }

  .doctor-header--text {
    font-family: 'Fira Sans', sans-serif;
    font-size: 50px;
    line-height: 50px;
    font-weight: 900;
    width: 50%;
    color: #fff;
    padding-left: 10px;
    padding-top: 20px;
    text-transform: uppercase;
  }

  .button-container--text {
    font-family: 'Fira Sans', sans-serif;
    font-size: 26px;
    font-weight: 900;
    color: #fff;
    text-decoration: none;
    text-transform: uppercase;
  }

  .button-container--arrow {
    margin-right: 20px
  }

  .free-main-header--margin {
    margin-top: 100px;
  }

  .button-container--margin {
    margin-bottom: 30px;
  }

  .button-container--padding {
    padding-top: 50px !important;
    padding-bottom: 50px !important;
  }

  .button-container--position {
    display: flex;
    justify-content: center;
    flex-direction: column;
    align-items: flex-end;
  }

  .button-container--separator {
    position: absolute;
    top: 0;
    width: 115px;
    height: 10px;
    background: #ffffff;
  }

  .register-container--download {
    text-decoration: none;
    display: flex;
    vertical-align: middle;
    -webkit-box-orient: horizontal;
    -webkit-box-direction: normal;
    -ms-flex-direction: row;
    flex-direction: row;
    -webkit-box-align: center;
    -ms-flex-align: center;
    align-items: center;
  }

  .register-container--download-text {
    display: flex;
    vertical-align: middle;
    -webkit-box-orient: horizontal;
    -webkit-box-direction: normal;
    -ms-flex-direction: column;
    flex-direction: column;
    -webkit-box-align: center;
    -ms-flex-align: center;
    align-items: flex-start;
    padding-left: 15px;
  }

  .register-container--sections {
    color: #275271;
    font-family: 'Fira Sans', sans-serif;
    font-weight: 900;
    text-transform: uppercase;
  }
</style>



// WEBPACK FOOTER //
// src/components/ForumRegister.vue